"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Middleware_helpers_1 = require("../Middleware.helpers");
/**
 * Notification Middleware will intercept any pre-defined actions and emit
 * an event to show up a notification or any necessary behavior when those actions
 * get dispatched.
 * @param config
 * @param store
 * @param next
 * @param action
 */
var notificationMiddleware = function (config) { return function () { return function (next) { return function (action) {
    var hasType = Middleware_helpers_1.contains(config.actions, action.type);
    if (hasType) {
        config.onNotify(action);
    }
    return next(action);
}; }; }; };
exports.default = notificationMiddleware;
//# sourceMappingURL=NotificationMiddleware.js.map